$(document).ready(function(){
  const videoLightbox = GLightbox({
      selector: null, // we will open manually
      touchNavigation: true,
      loop: false
    });

    //tm7 landing page
    tm7PageVideoTabSection();
    tm7PageImageSliderSection();
    tm7PageVideoSection();

    //Custom add to cart buttons 
    document.querySelectorAll('.js-finder-show-cart').forEach(function(el) {
      el.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          $('body').removeClass('consultant-confirmation-active');
          document.dispatchEvent(new CustomEvent('cart:build'));
          var toggle = document.querySelector('#HeaderCartTrigger');
          if (toggle) {
            toggle.click();
          }
      }, true);
    });        
    
  document.querySelectorAll('.js-buy-now-add-to-cart').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      var variantId = parseInt(el.getAttribute('data-variant-id')) ||50802348622126; //tm7
      var maxQty = 2;
      var href = el.getAttribute('href');

      fetch('/cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          var currentQty = 0;
          cart.items.forEach(function(item) {
            if (item.variant_id === variantId) {
              currentQty += item.quantity;
            }
          });

          if (currentQty >= maxQty) {
            var toggle = document.querySelector('#HeaderCartTrigger');
            if (toggle) {
              toggle.click();
            }
            return;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
          })
          .then(function(res) {
            if (res.ok) {
              document.dispatchEvent(new CustomEvent('cart:build'));
              var toggle = document.querySelector('#HeaderCartTrigger');
              if (toggle) {
                toggle.click();
              }
            }
          })
          .catch(function() {
            // handle error
          });
        });
    }, true);
  });

  document.querySelectorAll('.js-open-video-popup').forEach(function (el) {
    el.addEventListener(
      'click',
      function (e) {
        // Block theme interception + navigation
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        const videoUrl = el.getAttribute('href');

        videoLightbox.setElements([
          {
            href: videoUrl,
            type: 'video'
          }
        ]);

        if (el.classList.contains('video-vertical')) {
          document.documentElement.classList.add('video-vertical-active');
        } else {
          document.documentElement.classList.remove('video-vertical-active');
        }        

        videoLightbox.open();
      },
      true // capture phase is critical
    );
  });
  
    //Enable this code if consultant finder is enabled
    document.addEventListener('cart:built', function(data) {
        const tm6LineItem = document.querySelectorAll('.cart__items #cart__item.cart__item.tm6_product')
        const hasTm6 = tm6LineItem?.length

        let referralConsultantCookie = Cookies.get('referral_consultant_id');

        if (hasTm6) {
          if (referralConsultantCookie) {            
            $('.continue-without-consultant-btn').addClass('hide')
            $('button[name="checkout"]').removeClass('hide')
            $('.find-consultant-section.find-consultant-cart-widget').addClass('hide')
          } else if ($('button[name="checkout"]').hasClass('donothide')) {
            $('.continue-without-consultant-btn').addClass('hide')
            $('button[name="checkout"]').removeClass('hide')
            $('.find-consultant-section.find-consultant-cart-widget').addClass('hide')
          } else if($('button[name="checkout"]').hasClass('donothideconsultantfinder')) {
            $('.continue-without-consultant-btn').addClass('hide')
            $('button[name="checkout"]').removeClass('hide')            
            $('.find-consultant-section.find-consultant-cart-widget').removeClass('hide')            
          } else {
            $('.continue-without-consultant-btn').removeClass('hide')
            $('button[name="checkout"]').addClass('hide')
            $('.find-consultant-section.find-consultant-cart-widget').removeClass('hide')          
          }           
        }
        else {
            $('.continue-without-consultant-btn').addClass('hide')
            $('button[name="checkout"]').removeClass('hide')
            $('.find-consultant-section.find-consultant-cart-widget').addClass('hide')
        }
    });
  
    var width = $(window).width();
    if(width > 768){
      if($('.video-parent-section .hero__media-container.small--hide video[data-type="mp4"]')){
        setTimeout(function() {
          $('.video-parent-section .hero__media-container.small--hide .hero-media-poster').hide();
        }, 1000);
      }
    var isALARendered;
    function ALAcheck() {
      isALARendered = setInterval(function () {
        customALA()
      }, 200);
    }
    ALAcheck();
    function customALA() {
    var selector = $('.video-parent-section .hero__media-container.small--hide iframe');
      if(selector.length > 0) {
        clearInterval(isALARendered);        
        var play_id = $('.video-parent-section .hero__media-container.small--hide').find('iframe').attr('data-video-id');
        $('.video-parent-section .hero__media-container.small--hide').find('iframe')[0].src += "&loop=1&playlist="+play_id;
      }  
    }
      
    }else{
      if($('.video-parent-section .hero__media-container.medium-up--hide video[data-type="mp4"]')){
        setTimeout(function() {
          $('.video-parent-section .hero__media-container.medium-up--hide .hero-media-poster').hide();
        }, 1000);
      }
      if($('.hero__media-container.medium-up--hide iframe').length > 0){
      $('.hero__media-container.medium-up--hide iframe.video-mobile-div[data-type="youtube"]')[0].src += "&autoplay=1&mute=1&loop=1&playsinline=1";
      }
      var isALARendered;
      function ALAcheck() {
        isALARendered = setInterval(function () {
          customALA()
        }, 200);
      }
      ALAcheck();
      function customALA() {
      var selector = $('.hero__media-container.medium-up--hide iframe.video-mobile-div[data-type="youtube"]').contents().find("body");
        if(selector.length > 0) {
          clearInterval(isALARendered);        
          let length = $('.hero__media-container.medium-up--hide iframe.video-mobile-div[data-type="youtube"]').contents().find("body").length;
            console.log(length);
          if(length > 0){
            console.log(length)
            $('.hero__media-container.medium-up--hide iframe.video-mobile-div[data-type="youtube"]').css('opacity','1');
            $('.hero__media-container.medium-up--hide .hero-media-poster').css('disaply','none');
          }
          setTimeout(function() {
            $('.hero__media-container.medium-up--hide iframe.video-mobile-div[data-type="youtube"]').css('opacity','1');
            $('.hero__media-container.medium-up--hide .hero-media-poster').css('disaply','none');
          }, 3000);
        }  
      }

    }

      // Video Slider JS
      $(document).on('click','.video-slider-around .video-slider-item .video-slider-poster svg', function() {
        let $this = $(this);

        // Remove the Auto Play directive from other videos
        $('.video-slider-around .video-slider-item').each(function() {
          var iframe_src =  $this.find('iframe')[0]?.src;

          if (iframe_src?.includes('autoplay')) {
            var updated_url = iframe_src.replace('&autoplay=1', '');
            $this.find('iframe').attr('src', updated_url);
            $this.find('.video-slider-poster').css('display','block');
          }
        });

        // Hide the poster image
        $(this).parent('.video-slider-poster').css('display','none');
        // Update the URL with autoplay to make it play
        let $yFrame = $(this).parent('.video-slider-poster').siblings('iframe')[0]
        $yFrame.src += "&autoplay=1";
      });
    
      var width = $(window).width();
      //for language seletor
      if(width > 1199){
        $('.toolbar__content .toolbar__item.small--hide').insertAfter('.next_languages');
      }else{
        $('.toolbar__content .toolbar__item.small--hide').insertAfter('li.account-nav');
        $('.slide-nav__wrapper .slide-nav .toolbar__item').removeClass('small--hide'); 
      }
    
        $(window).on('resize', function(){
          var win = $(this); //this = window
          if (win.height() >= 820) { /* ... */ }
          if (win.width() > 1199) {
            $('.toolbar__item.localization').insertAfter('.next_languages');
            $('.toolbar__item.localization').addClass('small--hide');
           }else{
            $('.toolbar__item.small--hide.localization').insertAfter('li.account-nav');
            $('.slide-nav__wrapper .slide-nav .toolbar__item').removeClass('small--hide'); 
           }
        });
    
      if($(window).width() <= 768){
        $(function() {
          $('.acc__title').click(function(j) {
            
            var dropDown = $(this).closest('.acc__card').find('.acc__panel');
            $(this).closest('.acc').find('.acc__panel').not(dropDown).slideUp();
            
            if ($(this).hasClass('active')) {
              $(this).removeClass('active');
            } else {
              $(this).closest('.acc').find('.acc__title.active').removeClass('active');
              $(this).addClass('active');
            }
            
            dropDown.stop(false, true).slideToggle();
            j.preventDefault();
          });
        });
        var flkty = new Flickity( '.membership-around', {
          cellAlign: 'left',
          pageDots: true,
          freeScroll: false,
          wrapAround: true,
          prevNextButtons: false,
          contain: true
        });
      }
    
      var flkty = new Flickity( '.join-video', {
          cellAlign: 'left',
          pageDots: true,
          freeScroll: false,
          wrapAround: true,
          prevNextButtons: true,
          contain: true
        });
      
      var flkty = new Flickity( '.j-step_img-slider', {
          cellAlign: 'left',
          pageDots: true,
          freeScroll: false,
          wrapAround: true,
          prevNextButtons: true,
          contain: true
        });
    
       $("#consultant").click(function() {
        if($(this).is(":checked")) {
            $(".select_consultant").hide();
        } else {
            $(".select_consultant").show();
        }
      });
    
      $.fn.moveIt = function(){
      var $window = $(window);
      var instances = [];
      
      $(this).each(function(){
        instances.push(new moveItItem($(this)));
      });
      
      window.onscroll = function(){
        var scrollTop = $window.scrollTop();
        instances.forEach(function(inst){
          inst.update(scrollTop);
        });
      }
    }
    // Parallax effect
      // var moveItItem = function(el){
      //   this.el = $(el);
      //   this.speed = parseInt(this.el.attr('data-scroll-speed'));
      // };
      
      // moveItItem.prototype.update = function(scrollTop){
      //   var pos = scrollTop / this.speed;
      //   this.el.css('transform', 'translateY(' + -pos + 'px)');
      // };
      
      // $(function(){
      //   $('[data-scroll-speed]').moveIt();
      // });

    $(window).on("load scroll", function() {
      var parallaxElement = $(".parallax_scroll"),
        parallaxQuantity = parallaxElement.length;
      window.requestAnimationFrame(function() {
        for (var i = 0; i < parallaxQuantity; i++) {
          var currentElement = parallaxElement.eq(i),
            windowTop = $(window).scrollTop(),
            elementTop = currentElement.offset().top,
            elementHeight = currentElement.height(),
            viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
            scrolled = windowTop - elementTop + viewPortHeight;
          currentElement.css({
            transform: "translate3d(0," + scrolled * -0.15 + "px, 0)"
          });
        }
      });
  });

  const loadVideoIframe = (slide) => {
    const isLoaded = slide.attr('data-loaded');
    if (!isLoaded) {
      const src = slide.attr('data-src');
      const iframe = `<iframe width="560" height="315" src="${src}" title="Video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
      slide.append(iframe);
      slide.attr('data-loaded', true)
    }
  }
      
      $('.rec-row').slick({
        dots:true,
        slidesToShow: 5.7,
        slidesToScroll: 5,
        responsive: [
          {
            breakpoint: 1441,
            settings: {
              slidesToShow: 6.28,
              slidesToScroll: 5,
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4.7,
              slidesToScroll: 4,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2.7,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 599,
            settings: {
              slidesToShow: 1.7,
              slidesToScroll: 1
            }
          }
        ]
      }); 
      
      $('.video-slider-around').on('init', function(event, slick, currentSlide, nextSlide) {
        const { originalSettings: { slidesToShow } } = slick;
        $(slick.$slides.slice(0, slidesToShow + 1)).find('.video-frame').each(function() {
          loadVideoIframe($(this));
        })
      });

      $('.video-slider-around').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        const { originalSettings: { slidesToShow } } = slick;
        $(slick.$slides.slice(nextSlide, nextSlide + slidesToShow)).find('.video-frame').each(function() {
          loadVideoIframe($(this));
        })
      });

      $('.video-slider-around').slick({
        dots: true,
        infinite: true,
        arrows:true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    
       $('.product-data-content').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        adaptiveHeight: true,
        asNavFor: '.product-data-list .pro-data-list-wrapp'
      });
      $('.product-data-list .pro-data-list-wrapp').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.product-data-content',
        dots: false,
        centerMode: false,
        adaptiveHeight: true,
        focusOnSelect: true,
        centerPadding:0
      });
    
      //TM6 Qty message
      if($('body').hasClass('template-product')){
      //for extend protection
      var isALARendered;
      function ALAcheck() {
        isALARendered = setInterval(function () {
          customALA()
        }, 200);
      }
      ALAcheck();
      function customALA() {
      // var selector = $('.extend-offer iframe');
      //   if(selector.length > 0) {
      //     if($('.add_to_cart_extra_text').length > 0){
      //       $('.extend-offer').insertAfter('.add_to_cart_extra_text');
      //     }else{
      //       $('.extend-offer').insertAfter('.form_btns');
      //     }
      //     $('.extend-offer').insertAfter('.add_to_cart_extra_text');
      //       var note_html = '<div class="extend_note"><p><strong>NOTE: </strong>a protection plan applies to the TM6® unit only, and not to TM6® accessories or other items in the cart.</p></div>';
      //       if($('.extend-offer iframe').length > 0){$('.extend-offer').append(note_html);}
      //       let head = $(".extend-offer iframe").contents().find("head");

      //       let css = '<style>/********* Put your styles here **********/  .component-container .caption-text{font-size: 16px;color: #919394;} .btn-content .divider{display:none;} .btn-content .term-length{color:#919394;font-size:12px;display: block;} .btn-content .plan-price{ font-size: 16px;font-weight: bold;color:#00ac46;} .button-group .button{border-radius: 4px;border: solid 1.5px #00ac46;} .no-touch .button-group .button:hover {background-color:#00ac46;box-shadow:none;border-color:#00ac46} .button-group .button.active {background-color:#00ac46;box-shadow:none;border-color:#00ac46} .button-group .button.active .btn-content .term-length,.button-group .button.active .btn-content .plan-price{color:#fff;}   .no-touch .button-group .button:hover .btn-content .plan-price, .no-touch .button-group .button:hover .btn-content .term-length{color:#fff;} .info-button .info-link{display: none;} .info-button .info-icon{display: inline-block} .info-button .info-icon g{fill:#000} .component-container .btn-offer + .btn-offer{margin-left:20px;} .component-container .button-group .button{padding:2px;}</style>';

      //       $(head).append(css);
          
      //     clearInterval(isALARendered);  
      //   }else{
      //     if($('.add_to_cart_extra_text').length > 0){
      //       $('.extend-offer').insertAfter('.add_to_cart_extra_text');
      //     }else{
      //       $('.extend-offer').insertAfter('.form_btns');
      //     }
      //   }    
      }
        //for affirm
      var affirm_pay;
      function ALAcheckaffirm() {
        affirm_pay = setInterval(function () {
          customALAaffirm()
        }, 200);
      }
      ALAcheckaffirm();
      function customALAaffirm() {
      var selector = $('.affirm-as-low-as');
        if(selector.length > 0) {
          if($('#bread-container').length > 0){
            $('#bread-container').parent('.shopify-app-block').addClass('as-low-as-terms')
            $('.affirm-as-low-as').insertAfter('#bread-container');
            $('.shopify-payment-terms.product__policies').insertAfter('.as-low-as-terms');
            $('.shopify-payment-terms.product__policies').show();
            $('<br>').insertBefore('.__affirm-logo');
          }else{
            $('.affirm-as-low-as').insertAfter('.product-block.product-block--price');
             $('.shopify-payment-terms.product__policies').insertAfter('.affirm-as-low-as');
          }
          
          clearInterval(affirm_pay);  

        }else{
          if($('#bread-container').length > 0){
            $('#bread-container').parent('.shopify-app-block').addClass('as-low-as-terms');
              $('.shopify-payment-terms.product__policies').insertAfter('.as-low-as-terms');
              $('.shopify-payment-terms.product__policies').show();
          }else{
            $('.shopify-payment-terms.product__policies').show();
             $('.shopify-payment-terms.product__policies').insertAfter('.product-block.product-block--price');
          }
        }    

      }
        var currenct_url = window.location.href;
        if($('.product__quantity').hasClass('tm6_product')){
        var pro_id = $('.product-section').attr('data-product-id');
         jQuery.getJSON('/cart.js', function(cart) {
                let cartData = cart.items;
                for(i = 0;i < cartData.length; i++){
                  if(cartData[i].product_id == pro_id){
                    if(cartData[i].quantity >= theme.settings.tm6PurchaseLimit){
                      $('.product-single__form button[type="submit"]').attr('disabled','disabled');
                      $('.product__quantity .js-qty__adjust--plus').attr('disabled','disabled');
                      $('.product__quantity .js-qty__num').attr('disabled','disabled');
                       $('.qty_error_msg').remove();
                       if(currenct_url.includes('ca/fr')){
                         var html = "<div class='qty_error_msg'>Maximum de " + theme.settings.tm6PurchaseLimit + ". Il est déjà dans votre panier.</div>"
                       }else{
                         var html = "<div class='qty_error_msg'>Maximum of " + theme.settings.tm6PurchaseLimit + ". It is already in your cart.</div>"
                       }
                       $(html).insertAfter('.product__quantity .js-qty__wrapper');
                    }else if(cartData[i].quantity == 1){
                      $('.product__quantity .js-qty__adjust--plus').attr('disabled','disabled');
                      $('.product-single__form button[type="submit"]').removeAttr('disabled');
                      $('.qty_error_msg').remove();
                       if(currenct_url.includes('ca/fr')){
                         var html = "<div class='qty_error_msg'>Maximum de " + theme.settings.tm6PurchaseLimit + ". Un est déjà dans votre panier.</div>"
                       }else{
                         var html = "<div class='qty_error_msg'>Maximum of " + theme.settings.tm6PurchaseLimit + ". One is already in your cart.</div>"
                       }
                      $(html).insertAfter('.product__quantity .js-qty__wrapper');
                    }else{
                      $('.qty_error_msg').remove();
                      $('.product-single__form button[type="submit"]').removeAttr('disabled');
                      $('.product__quantity .js-qty__adjust--plus').removeAttr('disabled');
                      $('.product__quantity .js-qty__num').removeAttr('disabled');
                    }
                  }
                }
              });
          $(document).on('click','.product-single__form button[type="submit"]', function(event){
             // event.preventDefault();
            setTimeout(function() {
               var pro_id = $('.product-section').attr('data-product-id');
              jQuery.getJSON('/cart.js', function(cart) {
                let cartData = cart.items;
                for(i = 0;i < cartData.length; i++){
                  if(cartData[i].product_id == pro_id){                
                    if(cartData[i].quantity >= theme.settings.tm6PurchaseLimit){
                      $('.product-single__form button[type="submit"]').attr('disabled','disabled');
                      $('.product__quantity .js-qty__adjust--plus').attr('disabled','disabled');
                      $('.product__quantity .js-qty__num').attr('disabled','disabled');
                       $('.qty_error_msg').remove();
                       if(currenct_url.includes('ca/fr')){
                         var html = "<div class='qty_error_msg'>Maximum de " + theme.settings.tm6PurchaseLimit + ". Il est déjà dans votre panier.</div>"
                       }else{
                         var html = "<div class='qty_error_msg'>Maximum of " + theme.settings.tm6PurchaseLimit + ". It is already in your cart.</div>"
                       }
                       $(html).insertAfter('.product__quantity .js-qty__wrapper');
                    }else if(cartData[i].quantity == 1){
                      $('.product__quantity .js-qty__adjust--plus').attr('disabled','disabled');
                      $('.product-single__form button[type="submit"]').removeAttr('disabled');
                      $('.qty_error_msg').remove();
                       if(currenct_url.includes('ca/fr')){
                         var html = "<div class='qty_error_msg'>Maximum de " + theme.settings.tm6PurchaseLimit + ". Un est déjà dans votre panier.</div>"
                       }else{
                         var html = "<div class='qty_error_msg'>Maximum of " + theme.settings.tm6PurchaseLimit + ". One is already in your cart.</div>"
                       }
                      $(html).insertAfter('.product__quantity .js-qty__wrapper');
                    }else{
                      $('.qty_error_msg').remove();
                      $('.product-single__form button[type="submit"]').removeAttr('disabled');
                      $('.product__quantity .js-qty__adjust--plus').removeAttr('disabled');
                      $('.product__quantity .js-qty__num').removeAttr('disabled');
                    }
                  }
                }
              });
              
            }, 1000);
          });
    
          $(document).on('click','.site-header__drawer .cart__items .js-qty__adjust', function(){
            var pro_id = $('.product-section').attr('data-product-id');
            var cart_pro_id = $(this).parents('.cart__item').attr('data-pro-id');
            if(cart_pro_id == pro_id){
              setTimeout(function() {
              jQuery.getJSON('/cart.js', function(cart) {
                let cartData = cart.items;
                if(cartData.length < 1){
                  $('.product-single__form button[type="submit"]').removeAttr('disabled');
                  $('.product__quantity .js-qty__adjust--plus').removeAttr('disabled');
                  $('.product__quantity .js-qty__num').removeAttr('disabled');
                  $('.qty_error_msg').remove();
                }
                for(i = 0;i < cartData.length; i++){
                  if(cartData[i].product_id == pro_id){
                    $('.qty_error_msg').remove();
                    if(cartData[i].quantity >= theme.settings.tm6PurchaseLimit){
                      $('.product-single__form button[type="submit"]').attr('disabled','disabled');
                      $('.product__quantity .js-qty__adjust--plus').attr('disabled','disabled');
                      $('.product__quantity .js-qty__num').attr('disabled','disabled');
                       $('.qty_error_msg').remove();
                       if(currenct_url.includes('ca/fr')){
                         var html = "<div class='qty_error_msg'>Maximum de " + theme.settings.tm6PurchaseLimit + ". Il est déjà dans votre panier.</div>"
                       }else{
                         var html = "<div class='qty_error_msg'>Maximum of " + theme.settings.tm6PurchaseLimit + ". It is already in your cart.</div>"
                       }
                       $(html).insertAfter('.product__quantity .js-qty__wrapper');
                    }else if(cartData[i].quantity == 1){
                      $('.product__quantity .js-qty__adjust--plus').attr('disabled','disabled');
                      $('.product-single__form button[type="submit"]').removeAttr('disabled');
                      $('.qty_error_msg').remove();
                       if(currenct_url.includes('ca/fr')){
                         var html = "<div class='qty_error_msg'>Maximum de " + theme.settings.tm6PurchaseLimit + ". Un est déjà dans votre panier.</div>"
                       }else{
                         var html = "<div class='qty_error_msg'>Maximum of " + theme.settings.tm6PurchaseLimit + ". One is already in your cart.</div>"
                       }
                      $(html).insertAfter('.product__quantity .js-qty__wrapper');
                      $('.product__quantity .js-qty__num').removeAttr('disabled');
                    }else{
                      $('.product-single__form button[type="submit"]').removeAttr('disabled');
                      $('.product__quantity .js-qty__adjust--plus').removeAttr('disabled');
                      $('.product__quantity .js-qty__num').removeAttr('disabled');
                      $('.qty_error_msg').remove();
                    }
                  }else{                  
                      $('.product-single__form button[type="submit"]').removeAttr('disabled');
                      $('.product__quantity .js-qty__adjust--plus').removeAttr('disabled');
                      $('.product__quantity .js-qty__num').removeAttr('disabled');
                      $('.qty_error_msg').remove();
                  }
                }
              });
              },1000);
            }
          });
        }
        $(document).on('click','.product__quantity .js-qty__adjust', function(){
          if($('.product__quantity').hasClass('tm6_product')){
            var value_qty = $('[name="quantity"]').val();
            var pro_id = $('.product-section').attr('data-product-id');
            
            if(value_qty > 1 && value_qty >= theme.settings.tm6PurchaseLimit){
              $('.js-qty__adjust--plus').attr('disabled','disabled');
               if(currenct_url.includes('ca/fr')){
                 var html = "<div class='qty_error_msg'>Maximum de " + theme.settings.tm6PurchaseLimit + "</div>"
               }else{
                 var html = "<div class='qty_error_msg'>Maximum of " + theme.settings.tm6PurchaseLimit + "</div>"
               }
              $(html).insertAfter('.js-qty__wrapper');

              if (theme.settings.tm6PurchaseLimit == 1) {
                $('[name="quantity"]').val(1);
              }
            }else{
              jQuery.getJSON('/cart.js', function(cart) {
                let cartData = cart.items;
                if(cartData.length < 1){              
                  $('.product-single__form button[type="submit"]').removeAttr('disabled');
                  $('.product__quantity .js-qty__adjust--plus').removeAttr('disabled');
                  $('.product__quantity .js-qty__num').removeAttr('disabled');
                  $('.qty_error_msg').remove();
                }
                for(i = 0;i < cartData.length; i++){
                  if(cartData[i].product_id == pro_id){
                    if(cartData[i].quantity >= theme.settings.tm6PurchaseLimit){
                      $('.product-single__form button[type="submit"]').attr('disabled','disabled');
                      $('.product__quantity .js-qty__adjust--plus').attr('disabled','disabled');
                      $('.product__quantity .js-qty__num').attr('disabled','disabled');
                       $('.qty_error_msg').remove();
                       if(currenct_url.includes('ca/fr')){
                         var html = "<div class='qty_error_msg'>Maximum de " + theme.settings.tm6PurchaseLimit + ". Il est déjà dans votre panier.</div>"
                       }else{
                         var html = "<div class='qty_error_msg'>Maximum of " + theme.settings.tm6PurchaseLimit + ". It is already in your cart.</div>"
                       }
                       $(html).insertAfter('.product__quantity .js-qty__wrapper');
                    }else if(cartData[i].quantity == 1){
                      $('.product__quantity .js-qty__adjust--plus').attr('disabled','disabled');
                      $('.product-single__form button[type="submit"]').removeAttr('disabled');
                      $('.qty_error_msg').remove();
                       if(currenct_url.includes('ca/fr')){
                         var html = "<div class='qty_error_msg'>Maximum de " + theme.settings.tm6PurchaseLimit + ". Un est déjà dans votre panier.</div>"
                       }else{
                         var html = "<div class='qty_error_msg'>Maximum of " + theme.settings.tm6PurchaseLimit + ". One is already in your cart.</div>"
                       }
                      $(html).insertAfter('.product__quantity .js-qty__wrapper');
                    }else{
                      $('.qty_error_msg').remove();
                      $('.product-single__form button[type="submit"]').removeAttr('disabled');
                      $('.product__quantity .js-qty__adjust--plus').removeAttr('disabled');
                      $('.product__quantity .js-qty__num').removeAttr('disabled');
                    }
                  }else{
                      $('.product-single__form button[type="submit"]').removeAttr('disabled');
                      $('.product__quantity .js-qty__adjust--plus').removeAttr('disabled');
                      $('.product__quantity .js-qty__num').removeAttr('disabled');
                      $('.qty_error_msg').remove();
                  }
                }
              });
            }
          }
        });
        $(document).on('change','.product__quantity .js-qty__num', function(){
          if($('.product__quantity').hasClass('tm6_product')){
            var value_qty = $('[name="quantity"]').val();
            var pro_id = $('.product-section').attr('data-product-id');
            if(value_qty > theme.settings.tm6PurchaseLimit){
              $('.qty_error_msg').remove();
              jQuery.getJSON('/cart.js', function(cart) {
                let cartData = cart.items;
                if(cartData.length < 1){              
                  $('.product__quantity .js-qty__num').val(2);
                  $('.js-qty__adjust--plus').attr('disabled','disabled');
                   if(currenct_url.includes('ca/fr')){
                     var html = "<div class='qty_error_msg'>Maximum de " + theme.settings.tm6PurchaseLimit + "</div>"
                   }else{
                     var html = "<div class='qty_error_msg'>Maximum of " + theme.settings.tm6PurchaseLimit + "</div>"
                   }
                  $(html).insertAfter('.js-qty__wrapper');
                }
                for(i = 0;i < cartData.length; i++){
                  if(cartData[i].product_id == pro_id){
                    if(cartData[i].quantity >= theme.settings.tm6PurchaseLimit){
                      $('.product__quantity .js-qty__num').val(1);
                      $('.product-single__form button[type="submit"]').attr('disabled','disabled');
                      $('.product__quantity .js-qty__adjust--plus').attr('disabled','disabled');
                      $('.product__quantity .js-qty__num').attr('disabled','disabled');
                       $('.qty_error_msg').remove();
                       if(currenct_url.includes('ca/fr')){
                         var html = "<div class='qty_error_msg'>Maximum de " + theme.settings.tm6PurchaseLimit + ". Il est déjà dans votre panier.</div>"
                       }else{
                         var html = "<div class='qty_error_msg'>Maximum of " + theme.settings.tm6PurchaseLimit + ". It is already in your cart.</div>"
                       }                   
                       $(html).insertAfter('.product__quantity .js-qty__wrapper');
                    }else if(cartData[i].quantity == 1){
                      $('.product__quantity .js-qty__num').val(1);
                      $('.product__quantity .js-qty__adjust--plus').attr('disabled','disabled');
                      $('.product-single__form button[type="submit"]').removeAttr('disabled');
                      $('.qty_error_msg').remove();
                       if(currenct_url.includes('ca/fr')){
                         var html = "<div class='qty_error_msg'>Maximum de " + theme.settings.tm6PurchaseLimit + ". Un est déjà dans votre panier.</div>"
                       }else{
                         var html = "<div class='qty_error_msg'>Maximum of " + theme.settings.tm6PurchaseLimit + ". One is already in your cart.</div>"
                       }                  
                      $(html).insertAfter('.product__quantity .js-qty__wrapper');
                    }else{
                      $('.qty_error_msg').remove();
                      $('.product-single__form button[type="submit"]').removeAttr('disabled');
                      $('.product__quantity .js-qty__adjust--plus').removeAttr('disabled');
                      $('.product__quantity .js-qty__num').removeAttr('disabled');
                    }
                  }else{
                      $('.product-single__form button[type="submit"]').removeAttr('disabled');
                      $('.product__quantity .js-qty__adjust--plus').removeAttr('disabled');
                      $('.product__quantity .js-qty__num').removeAttr('disabled');
                      $('.qty_error_msg').remove();
                  }
                }
              });
              
              return false;
            }else if(value_qty == theme.settings.tm6PurchaseLimit){
              $('.qty_error_msg').remove();
              $('.js-qty__adjust--plus').attr('disabled','disabled');
               if(currenct_url.includes('ca/fr')){
                 var html = "<div class='qty_error_msg'>Maximum de " + theme.settings.tm6PurchaseLimit + "</div>"
               }else{
                 var html = "<div class='qty_error_msg'>Maximum of " + theme.settings.tm6PurchaseLimit + "</div>"
               } 
              $(html).insertAfter('.js-qty__wrapper');
            }else{
              $('.product-single__form button[type="submit"]').removeAttr('disabled');
              $('.product__quantity .js-qty__adjust--plus').removeAttr('disabled');
              $('.product__quantity .js-qty__num').removeAttr('disabled');
              $('.qty_error_msg').remove();
            }
          }
        });
      } 
    });

function tm7PageVideoTabSection(){
  const titles = document.querySelectorAll('.video-tab [data-tab-title]');
  const contents = document.querySelectorAll('.video-tab [data-tab-content]');

  if(titles.length && contents.length){
    
    titles.forEach((title) => {

      title.addEventListener('click', function(e){
        e.preventDefault();
        titles.forEach(t => t.classList.remove('active'));
        e.target.classList.add('active');
        const dataIndex = Number(e.target.dataset.index || 1);

        contents.forEach(cnt => {
          cnt.classList.remove('active');
          const video = cnt.querySelector('video');
          const videoIframe = cnt.querySelector('iframe');
          const playBtn = cnt.querySelector('.play-btn');
          const pauseBtn = cnt.querySelector('.pause-btn');
          if (video) {
            video.pause();
          }else if(videoIframe){
            let iframeSrc = videoIframe.getAttribute('src');
            if (iframeSrc.includes('vimeo.com')) {
              videoIframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
            } else {
              videoIframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo' }), '*');
            }
          }
          if (playBtn && pauseBtn) {
            playBtn.classList.remove(`hide`);
            pauseBtn.classList.add(`hide`);
          }
        });
        
        contents[dataIndex].classList.add('active');
        const activeVideo = contents[dataIndex].querySelector('video');
        const activeVideoIframe = contents[dataIndex].querySelector('iframe');
        const playBtn = contents[dataIndex].querySelector('.play-btn');
        const pauseBtn = contents[dataIndex].querySelector('.pause-btn');
        if (activeVideo) {
          activeVideo.play();
          if (playBtn && pauseBtn) {
            playBtn.classList.add(`hide`);
            pauseBtn.classList.remove(`hide`);
          }
        } else if(activeVideoIframe){
          let iframeSrc = activeVideoIframe.getAttribute('src');
          if (iframeSrc.includes('?autoplay=0')) {
            const newSrc = iframeSrc.replace('?autoplay=0', '?autoplay=1&muted=1');
            activeVideoIframe.setAttribute('src', newSrc);
          }
          if (iframeSrc.includes('vimeo.com')) {
            activeVideoIframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
          } else {
            activeVideoIframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo' }), '*');
          }
        }

      });
    });

    contents.forEach(content => {
      const video = content.querySelector('video');
      const playBtn = content.querySelector('.play-btn');
      const pauseBtn = content.querySelector('.pause-btn');
      if (video && playBtn && pauseBtn) {
        playBtn.addEventListener('click', () => {
          video.play();
          playBtn.classList.add(`hide`);
          pauseBtn.classList.remove(`hide`);
        });
        pauseBtn.addEventListener('click', () => {
          video.pause();
          playBtn.classList.remove(`hide`);
          pauseBtn.classList.add(`hide`);
        });
      }
    });

  }
}

function tm7PageImageSliderSection(){
  const sliderElements = $('.image-slider-section [data-image-slider]');
  if (sliderElements.length) {
    sliderElements.each(function() {
      const $this = $(this);
      $this.slick({
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        appendDots: $this.closest('.image-slider-main').find('.image-slider-controls'),
        appendArrows: $this.closest('.image-slider-main').find('.image-slider-controls')
      });
    });
  }
}

function tm7PageVideoSection() {
  const thumbButtons = document.querySelectorAll('.video-section [data-iframe-poster]');
  if (thumbButtons.length) {
    thumbButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        this.classList.add('hide');
        const closestEle = this.closest('.video-wrapper')?.querySelector('iframe');

        if (closestEle) {
          let iframeSrc = closestEle.getAttribute('src');
          if (iframeSrc.includes('?autoplay=0')) {
            const newSrc = iframeSrc.replace('?autoplay=0', '?autoplay=1&muted=1');
            closestEle.setAttribute('src', newSrc);
          }
          if (iframeSrc.includes('vimeo.com')) {
            closestEle.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
          } else {
            closestEle.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo' }), '*');
          }
        }
      });
    });
  }
}


var common = (function(){

  var debounce = function (fn, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
          fn.apply(context, args);
        }, wait);
    };
  };

  var addClasses = function (n, classes) {
    let index = 0;
    const node = document.getElementById(n);

    const intervalId = setInterval(() => {
        if (index < classes.length) {
            node.classList.add(classes[index]);
            index++;
        } else {
            clearInterval(intervalId); // Stop the interval when all classes are added
        }
    }, 650);
  };

  var skipToContent = function(e) {
      e.preventDefault();
      console.log("Skipping to main content");
      const mainContent = document.getElementById('main-content');
      mainContent.focus({ preventScroll: true });
  };

  var vh = function() {
      //Required for mobile vh
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  return {
      debounce: debounce,
      addClasses: addClasses,
      skipToContent: skipToContent,
      vh: vh
  };

})();

// User Identity Tracking
(function () {

  if (
    window.Shopify &&
    Shopify.country &&
    Shopify.country !== 'US'
  ) {
    return;
  }

  function getEmailInput(form) {
    if (!form) return null;

    return form.querySelector(`
      input[type="email"],
      input[name="contact[email]"],
      input[name="customer[email]"],
      input[name="email"]
    `);
  }

  function isTrackableForm(form) {
    if (!form || !form.action) return false;

    const action = form.action;

    return (
      action.includes('/contact') ||
      action.includes('/comments') ||
      action.includes('/account/login') ||
      action.includes('/account/register') ||
      form.querySelector(
        'input[name="contact[tags]"][value*="newsletter"]'
      )
    );
  }

  document.addEventListener(
    'submit',
    async function (event) {
      const form = event.target;

      if (!isTrackableForm(form)) return;

      try {
        const emailInput = getEmailInput(form);
        const email = emailInput?.value?.trim();

        if (!email) return;

        await window.UserIdentity.identify(email);
      } catch (error) {
        console.error(
          'User identity tracking failed',
          error
        );
      }
    },
    true
  );
})();

document.addEventListener(
  'click',
  async function (event) {
    const submitButton = event.target.closest(
      '.klaviyo-form button'
    );
    if (!submitButton) return;

    try {
      const form = submitButton.closest('form');
      if (!form) return;

      const emailInput = form.querySelector(
        'input[type="email"], input[name="email"]'
      );
      const email = emailInput?.value?.trim();
      if (!email) return;
      await window.UserIdentity.identify(email);
    } catch (error) {
      console.error(
        'Klaviyo identity tracking failed',
        error
      );
    }
  },
  true
);